import $global from '@xt/client/store/global'

export function mapStickerPaths(text: string, spliter = ',') {
  return text
    .split(spliter)
    .filter(Boolean)
    .map(item => {
      const [groupName, stickerIndex] = item.split(':')

      return getStickerPath(groupName, stickerIndex)
    })
}

export function getStickerPath(groupName: string, stickerIndex: string) {
  return `${$global.static}/images/sticker/${groupName}/${stickerIndex}.png`
}

export function getStickerCoverPath(groupName: string) {
  return `${$global.static}/images/sticker/${groupName}/cover.png`
}

export function getStickerPattern(groupName: string, stickerIndex: string) {
  return `${groupName}:${stickerIndex}`
}

// 直播间单张图
export function withSchemaPattern(pattern: string) {
  return `sticker://${pattern}`
}

export function isStickerSchemaPattern(text: string) {
  return text.trim().startsWith('sticker://')
}

export function getStickerPathBySchemaPattern(schemaPattern: string) {
  return getStickerPathByPattern(schemaPattern.replace("sticker://", ""))
}

export function getStickerPathByPattern(pattern: string) {
  const [groupName, stickerIndex] = pattern.split(':')
  return getStickerPath(groupName, stickerIndex)
}
